import { render } from "./SpecialRatingControl.vue?vue&type=template&id=92221474&scoped=true"
import script from "./SpecialRatingControl.vue?vue&type=script&lang=js"
export * from "./SpecialRatingControl.vue?vue&type=script&lang=js"

import "./SpecialRatingControl.vue?vue&type=style&index=0&id=92221474&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92221474"]])

export default __exports__